const RelatedList = require('module/user/related_list')
const Domain = require('module/user/domain')

const DomainList = RelatedList.extend({

    id: 'mapped_domains',

    model: Domain,

    getDomain() {
        const canonical_domain = this.findWhere(domain => domain.get('canonical'))
        return canonical_domain || this.first()
    },

})

module.exports = DomainList
